// extracted by mini-css-extract-plugin
export var growableInput = "_3a-0";
export var tagContainer = "_3a-2";
export var textInput = "_3a-1";